import * as rxjs from 'rxjs'

/**
 * Gives the browser one committed paint before running expensive navigation
 * work. The first frame lets Angular render the transition overlay; the second
 * frame starts navigation after that overlay has had a chance to appear.
 */
export function waitForPaint$(): rxjs.Observable<unknown> {
  return rxjs.animationFrames().pipe(
    // Frame 1 lets Angular commit the transition state to the DOM.
    rxjs.take(2),
    // Frame 2 gives the browser a chance to paint before route work begins.
    rxjs.last(),
  )
}
